import React, { useReducer } from 'react'
import ReturnContext from './returnContext'
import ReturnReducer from './returnReducer'
import { apiCall, apiCallSeller } from '../../common/api'
import { response } from '../common'

import {
    GET_ALL_SEARCH,
    CLEAR_RESPONSE,
    RESPONSE_STATUS,
    GET_SINGLE_CART,
    GET_AVAILABLE_APPOINT,
} from './returnTypes'

const ReturnState = (props) => {
    const initialState = {
        search_allproducts: {
            cartrecords: [],
            noncartrecords: [],
        },
        search_singlecart: {
            cartrecords: [],
            cartvalues: {},
            cartLocation: {},
        },
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(ReturnReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getSingleCartProducts = async (formData) => {
        try {
            const [res] = await Promise.all([apiCall('post', 'checkout', formData, '', 'return')])
            const from = 'cartsearch'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_CART,
                    payload: {
                        cartrecords: res.data.data.responseData.cartItems.length
                            ? res.data.data.responseData.cartItems
                            : [],
                        cartvalues: res.data.data.responseData.cartValues,
                        cartLocation: res.data.data.responseData.cartLocation,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse('cartsearch')
        }
    }

    const getAllCartProducts = async (formData) => {
        try {
            const [res] = await Promise.all([apiCall('post', 'search', formData, '', 'return')])
            const from = 'cartsearch'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_SEARCH,
                    payload: {
                        cartrecords: res.data.data.responseData.cartItems.length
                            ? res.data.data.responseData.cartItems
                            : [],
                        noncartrecords: res.data.data.responseData.nonCartItems.length
                            ? res.data.data.responseData.nonCartItems
                            : [],
                    },
                })
            } else if (res.data.status === 'error') {
                dispatch({
                    type: RESPONSE_STATUS,
                    payload: {
                        status: res.data.status,
                        message: res.data.data.message,
                        type: res.data.data.responseType,
                        from: from,
                    },
                })
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse('cartsearch')
        }
    }

    // Register User
    const changeOnCart = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'changeStatus', formData, '', 'return'),
            ])
            resp.commonResponse(res.data, 'cartchange')
        } catch (err) {
            resp.commonErrorResponse('cartchange')
        }
    }

    const saveAddress = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'saveAddress', formData, '', 'return'),
            ])
            resp.commonResponse(res.data, 'cartaddress')
        } catch (err) {
            resp.commonErrorResponse('cartaddress')
        }
    }

    const refundInvoiceStatus = async (formData) => {
        try {
            const from = 'refundInvoiceStatus'
            const [res] = await Promise.all([
                apiCallSeller('post', 'refundInvoice', formData, '', 'refund'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const raiseRequest = async (formData, custom, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'raiseRequest'
            const [res] = await Promise.all([
                apiCall('post', 'raise_request', formData, '', 'return', custom ? true : null),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const cancelRequest = async (formData, custom, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'cancelRequest'
            const [res] = await Promise.all([
                apiCall('post', 'cancel_request', formData, '', 'return', custom ? true : null),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getRaiseRequest = async (formData, custom, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'getRaiseRequest'
            const [res] = await Promise.all([
                apiCall('post', 'get_raise_request', formData, '', 'return', custom ? true : null),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <ReturnContext.Provider
            value={{
                search_allproducts: state.search_allproducts,
                search_singlecart: state.search_singlecart,
                responseStatus: state.responseStatus,
                getSingleCartProducts,
                clearResponse,
                saveAddress,
                getAllCartProducts,
                changeOnCart,
                refundInvoiceStatus,
                raiseRequest,
                getRaiseRequest,
                cancelRequest,
            }}
        >
            {props.children}
        </ReturnContext.Provider>
    )
}

export default ReturnState
